import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { Button } from 'react-bootstrap';
import '../styles/modalCss.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { faX } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios'

const NewPlayerModal = ({ isOpen, onRequestClose, gameID }) => {
  const [newPlayerName, setNewPlayerName] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const token = localStorage.getItem('token');

  useEffect(() => {
    setErrorMsg('');
  }, [newPlayerName])

  const handleInputChange = (e) => {
    setNewPlayerName(e.target.value);
  };

  const handleSubmit = () => {
    if (newPlayerName === '') {
      setErrorMsg('יש להכניס שם של שחקן!');
      return
    }

    axios.post(`https://kaskas.pro/poker-stats-server/api/api/addNewPlayer`, { newPlayerName, gameID }, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).then(response => {
      let addPlayerResult = response.data.addPlayerResult
      if (addPlayerResult.status) {
        onRequestClose();
        return;
      }
      setErrorMsg(addPlayerResult.message);

    }).catch(err => {
      setErrorMsg('Error');
      console.log(`Error fetching data:${err}`)
    })

  };

  const handleAfterOpen = () => {
    setNewPlayerName('');
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      onAfterOpen={handleAfterOpen}
    >
      <div className='modalContainer'>
        <button className="closeButton" onClick={onRequestClose}>X</button>
        <h2 className='modalHeader'>הוספת שחקן חדש:</h2>
        <input
          type="text"
          value={newPlayerName}
          onChange={handleInputChange}
          placeholder="הכניסו שם של שחקן"
          className='modalInput'
        />
        {errorMsg ? <h3 className='errorMsg'>{errorMsg}</h3> : null}
        <div className='btnsContainer'>
          <Button className='modalbtns' variant='success' onClick={handleSubmit}>אישור  <FontAwesomeIcon icon={faCheck} /> </Button>
          <Button className='modalbtns' variant='danger' onClick={() => onRequestClose()}>ביטול  <FontAwesomeIcon icon={faX} /></Button>
        </div>
      </div>
    </Modal>
  );
};

export default NewPlayerModal;
